/*
 * Constants relating to messages added to the bottom of the page.
 */

/**
 * ID of element to prepend or append messages to.
 * @type {string}
 */
const BOTTOM_MESSAGES_DOM_ID = 'fixed-bottom-messages';

export {
  BOTTOM_MESSAGES_DOM_ID
};
